import drawLotNumbers from './drawLotNumbers';
import { Button, Header, Icon, Message } from '../../components';

import React from 'react';
import { filter, map } from 'lodash';
import uuid from 'uuid/v4';

const buttonStyle = { width: '12em' };

const Verification = ({ contests, entries, groups, actions }) => {
  const onClickDrawLots = () => {
    const lotNumbers = drawLotNumbers(entries.length);
    const lots = entries.map((entry, i) => ({
      number: lotNumbers[i],
      entry: entry.primaryKey,
      uuid: uuid(),
    }));
    actions.lot.resetAll(lots);
  };

  const onClickClearLots = () => {
    actions.lot.resetAll([]);
  };

  // TODO: Format this into <Step>s.
  // TODO: Consolidate warnings and sanity checks to dashboard?
  const missingLots = filter(entries, entry => entry.lotNumber === undefined);

  return (
    <section>
      {/*
    <Header as="h1">Entry verification</Header>
    <p>
      <Button content="Verify entries" style={buttonStyle} />
    </p>
    */}
      <Header as="h2">Drawing of lots</Header>
      <p>
        {!missingLots.length && <Icon key={1} name="checkmark" color="green" />}
        {missingLots.length === 0
          ? 'Lot draw has been completed.'
          : 'Lot draw has not been completed yet.'}
      </p>
      {![entries.length, 0].includes(missingLots.length) && (
        <Message
          icon="warning circle"
          header={`${missingLots.length} entries are missing lot numbers!`}
          content={map(missingLots, 'title').join(', ')}
          warning
        />
      )}
      <p>
        <Button
          content="Draw lots"
          disabled={!missingLots.length}
          onClick={onClickDrawLots}
          style={buttonStyle}
          positive
        />
        <Button
          icon="warning sign"
          content="Clear lots"
          disabled={missingLots.length === entries.length}
          onClick={onClickClearLots}
          negative
          style={buttonStyle}
        />
      </p>
    </section>
  );
};

export default Verification;



// WEBPACK FOOTER //
// ./src/pages/Entry/Verification.js